const getPath = function (url) {
  return new URL(url).pathname
}

const getImageUrl = function (fileName, page) {
  if (!page) {
    throw new Error('getImageUrl: page required')
  }

  const file = page.files.find(file => `${file.name}.${file.extension}` === fileName)
  if (!file) {
    return
  }

  return file.url
}

export {
  getPath,
  getImageUrl
}
